function initializeElementsAndActions() {
  const checkboxes = document.querySelectorAll('input[name="related_companies[]"]');
  const relatedCompanies = document.querySelectorAll('.related__companies');
  const sectionSelectors = document.querySelectorAll('.select-section');
  const threadBtns = document.querySelectorAll('.thread-exchange-button');
  const printBtns = document.querySelectorAll('.print-button');
  const tabs = document.querySelectorAll('.tabs-nav li');
  const tabDivs = document.querySelectorAll('.tab-content');
  const pieceTabs = document.querySelectorAll('.pieces-tabs .piece-tab');

  relatedCompanies.forEach(el => {
    el.style.display = 'none';
  });

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const parentElement = checkbox.closest('.thread-exchange__companies');
      const checkedCount = parentElement.querySelectorAll('input[name="related_companies[]"]:checked').length;
      const selectedValues = Array.from(parentElement.querySelectorAll('input[name="related_companies[]"]:checked')).map(checkbox => checkbox.value);
      
      if(checkedCount >= 3){
        checkboxes.forEach(el => {
          if (!el.checked) {
              el.disabled = true;
          }
        });
      } else{
        checkboxes.forEach(el => {
          el.disabled = false;
        });
      }
    
      relatedCompanies.forEach(company => {
        if (selectedValues.includes(company.getAttribute('data-related-company'))) {
          company.style.display = '';
          company.classList.add('dynamic-element');
        } else {
          company.style.display = 'none';
          company.classList.remove('dynamic-element');
        }
      });

      if (checkbox.checked) {
        checkboxes.forEach(el => {
          if (el.value === checkbox.value && !el.checked) {
            el.checked = true; 
            el.disabled = false; 
          }
        });
      } else {
        checkboxes.forEach(el => {
          if (el.value === checkbox.value && el.checked) {
            el.checked = false;  
            el.disabled = false; 
          }
        });
      }
    });
  });

  sectionSelectors.forEach(checkbox => {
    checkbox.addEventListener('change', (event) => {
      const status = event.target.checked;
      const value = event.target.value;
      const targetElements = document.querySelectorAll(`.${event.target.value}`);
      const siblingElements = document.querySelectorAll(`input[value='${value}']`);
    
      targetElements.forEach(el=>{
        if(status){
          el.style.display = "block";
        }else{
          el.style.display = "none";
        }   
      });

      siblingElements.forEach(el => {
        el.checked = status;
      });
      
    });
  });

  threadBtns.forEach(threadBtn =>{
    threadBtn.addEventListener('click', () => {
      const parentElement = threadBtn.closest('.cc-thread-exchange');
      const targetElement = parentElement.querySelector('.thread-exchange');
      targetElement.scrollIntoView({ behavior: "smooth" });
   });   
  });
  
  printBtns.forEach(printBtn => {
    printBtn.addEventListener('click', () => {
      const printContents = document.querySelector('#panel-1').innerHTML;
      const printWindow = window.open('', '', 'height=600,width=800');
    
      printWindow.document.write(`<html>
        <head><title>Print</title>
          <style>
            .pack-grid {
              display: none !important;
            }
            .pieces-tabs {
              display: none !important;
            }
          </style>
        </head>
        <body>`);
      printWindow.document.write(printContents);
      printWindow.document.write('</body></html>');
    
      printWindow.document.close();
    
      printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
      };
    });    
  });

  tabs.forEach(tab =>{
    tab.addEventListener('click', (event) => {
      // Remove selected from any tabs that currently have the class
      document.querySelectorAll('.tabs-nav li.selected').forEach(element => {
        element.classList.remove('selected')
      })
      event.target.closest('li').classList.add('selected')

      const targetEle = tab.getAttribute('data-target');
      tabDivs.forEach(div => {
        div.style.display = "none";
      });
      document.getElementById(`${targetEle}`).style.display = "block";
    });
  });


  // Change piece of a multi-piece product - toggle a bunch of details
  pieceTabs.forEach(pieceTab =>{
    pieceTab.addEventListener('click', (event) => {
      const pieceName = pieceTab.getAttribute('data-piece'),
        colorsCount = pieceTab.getAttribute('data-changes'),
        uniqueCount = pieceTab.getAttribute('data-unique')

      pieceTabs.forEach(element => {
        element.classList.remove('active')
      })

      event.target.closest('.piece-tab').classList.add('active')
      document.querySelectorAll('.piece-name').forEach(element => {
        element.textContent = ' (Piece ' + pieceName + ')'
      })

      // Update counts for the selected piece
      document.querySelectorAll('.colors-count').forEach(element => {
        element.textContent = colorsCount
      })
      document.querySelectorAll('.unique-colors-count').forEach(element => {
        element.textContent = uniqueCount
      })

      // Toggle color stops for the selected piece
      document.querySelectorAll('.single-color').forEach(element => {
        element.style.display = 'none'
      })
      document.querySelectorAll('.single-color[data-piece="' + pieceName + '"]').forEach(element => {
        element.style.display = 'flex'
      })

      // Toggle Thread exchange rows for the selected piece
      document.querySelectorAll('.exchange-row').forEach(element => {
        element.style.display = 'none'
      })
      document.querySelectorAll('.exchange-row[data-piece="' + pieceName + '"]').forEach(element => {
        element.style.display = 'table-row'
      })
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeElementsAndActions()
});